import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { adminButton } from '@/components/admin/ui';
import { PLAN_NAME, type PlanKey } from '@/lib/plan-limits';

/** Shown in place of an AI feature the business's plan doesn't include. */
export function AiUpgradePrompt({
  feature,
  plan,
  children,
}: {
  feature: string;
  plan: PlanKey;
  children?: React.ReactNode;
}) {
  return (
    <div
      className="flex flex-col items-start gap-3 rounded-xl border border-border bg-secondary/50 p-4 text-[13.5px]"
      data-testid="ai-upgrade-prompt"
    >
      <div className="flex items-start gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Sparkles className="h-4 w-4" aria-hidden="true" />
        </span>
        <div className="space-y-1">
          <p className="font-semibold text-foreground">
            The {feature} is part of the {PLAN_NAME[plan]} plan
          </p>
          {children && <div className="text-muted-foreground">{children}</div>}
        </div>
      </div>
      <Button asChild size="sm" className={adminButton.primary}>
        <Link to="/admin/billing">
          Upgrade to {PLAN_NAME[plan]}
          <ArrowRight aria-hidden="true" />
        </Link>
      </Button>
    </div>
  );
}
